module.exports = __webpack_public_path__ + "static/media/message.e743ac5e.svg";